export const SET = 'Analysis/data/sets/SET';

export function setSets(sets) {
  return {
    type: SET,
    sets
  }
}